'use client';

import { DefaultValueConfig } from '@headless-workspace/config';
import {
    DynamicHrefValue,
    DynamicIconValue,
    DynamicLabelValue,
    isDynamicIconValue,
    isDynamicLabelValue,
} from '@headless-workspace/core-domain';
import { getIcon } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ConnectionBannerItem, useCountrySpecificities } from '../../../../../src';
import { ConnectionBannerItemWrapperProps } from './ConnectionBannerItemWrapper';
import { StaticConnectionBanner } from './StaticConnectionBanner';

type DynamicConnectionBannerProps = ConnectionBannerItemWrapperProps & {
    dynamicData: (DynamicHrefValue | DynamicIconValue | DynamicLabelValue)[];
};

export const DynamicConnectionBanner: Component<DynamicConnectionBannerProps> = ({
    connectionDataLayer,
    dynamicData,
    ...props
}) => {
    const { isLoading, data } = useCountrySpecificities(dynamicData);

    if (isLoading || !data) {
        return <StaticConnectionBanner connectionDataLayer={connectionDataLayer} {...props} />;
    }

    if (isDynamicLabelValue(data)) {
        return (
            <ConnectionBannerItem
                key={props.id}
                Icon={getIcon(data.iconName)}
                label={data.text}
                ariaLabel={props.ariaLabel}
                href={data.href ?? DefaultValueConfig.href}
                isRedDot={props.isRedDot}
                dataLayer={{
                    label: connectionDataLayer,
                }}
            />
        );
    }

    if (isDynamicIconValue(data)) {
        return (
            <ConnectionBannerItem
                key={props.id}
                Icon={getIcon(data.iconName)}
                label={props.label}
                ariaLabel={props.ariaLabel}
                href={props.href ?? DefaultValueConfig.href}
                isRedDot={props.isRedDot}
                dataLayer={{
                    label: connectionDataLayer,
                }}
            />
        );
    }

    return (
        <ConnectionBannerItem
            {...props}
            Icon={getIcon(props.iconName)}
            href={data.href}
            isRedDot={props.isRedDot}
            dataLayer={{
                label: connectionDataLayer,
            }}
        />
    );
};
